import type { TranslationKey } from "./en";

export const ptBR: Record<TranslationKey, string> = {
  // Header
  logout: "Sair",
  status_open: "Aberto",
  status_waitlist: "Lista de Espera",
  status_closed: "Fechado",

  // Navigation
  nav_profile: "Perfil",
  nav_portfolio: "Portfolio",
  nav_commissions: "Pedidos",
  nav_finances: "Financeiro",
  nav_reviews: "Avaliacoes",
  nav_settings: "Configuracoes",
  nav_section_commissions: "Pedidos",
  nav_section_settings: "Configuracoes",

  // Profile
  welcome_message: "Bem-vindo(a), {name}!",
  profile_subtitle: "Configure como os clientes veem voce no Studiocomm",
  profile_picture: "Foto de Perfil",
  profile_picture_hint:
    "Esta imagem aparecera no seu cartao de artista e perfil. Use uma imagem quadrada para melhores resultados.",
  upload_photo: "Enviar Foto",
  uploading: "Enviando...",
  basic_info: "Informacoes Basicas",
  avg_delivery: "Prazo Medio de Entrega (dias)",
  your_price_range: "Sua faixa de preco",
  price_range_auto: "Baseado nos seus pacotes de preco",
  no_prices_yet: "Adicione pacotes de preco para mostrar sua faixa",
  specializations: "Especializacoes",
  specializations_hint: "Que tipo de arte voce produz? (VTuber, Emotes, Concept Art, etc.)",
  commission_status: "Status das Comissoes",
  status_hint: 'Quando "Lista de Espera", clientes podem entrar na fila para serem notificados quando voce abrir vagas.',
  language_pref: "Idioma",
  language_hint: "Idioma do painel e das traducoes do Komiko",
  pricing_tiers: "Precos",
  pricing_hint: "Adicione seus tipos de trabalho e valores",
  add_tier: "+ Adicionar",
  additional_fees: "Taxas Adicionais",
  additional_fees_hint: "Defina cobrancas extras e escolha quais mostrar no seu perfil",
  fee_show: "Mostrar",
  fee_background_simple: "Fundo Simples",
  fee_background_complex: "Fundo Complexo",
  fee_extra_character: "Personagem Extra",
  fee_complex_design: "Design Complexo",
  fee_nsfw_content: "Conteudo NSFW",
  fee_commercial_use: "Uso Comercial",
  fee_rush_order: "Pedido Urgente",
  fee_custom: "Valor",
  fee_ask: "Perguntar",
  fee_dont_do: "Nao faco",
  social_links: "Redes Sociais",
  content_level: "Tipo de Conteudo",
  content_level_hint: "Que tipo de conteudo voce aceita?",
  nsfw_level_nsfw: "NSFW",
  nsfw_level_suggestive: "Sugestivo",
  nsfw_level_safe: "Apenas SFW",
  will_draw: "Temas Preferidos",
  will_draw_hint: "Quais temas voce gosta de desenhar? (OCs, Fantasia, Ficcao, etc.) Max. 8.",
  wont_draw: "Nao Desenho (Opcional)",
  wont_draw_hint: "Algo que voce prefere nao desenhar? Isso ajuda a definir expectativas. Max. 8.",
  add_custom_tag: "Adicionar tag",
  custom_tag_placeholder: "Digite e pressione Enter",
  max_tags_reached: "Máximo de tags atingido",
  quick_add_click: "Clique para adicionar/remover:",
  or_add_custom: "Ou adicione personalizado:",
  selected_tags: "Selecionados:",
  save_changes: "Salvar",
  saving: "Salvando...",
  profile_saved: "Perfil salvo!",
  save_success: "Salvo com sucesso!",
  upload_success: "Foto enviada com sucesso!",

  // Portfolio
  portfolio_title: "Portfolio",
  portfolio_subtitle: "Mostre suas melhores artes para atrair clientes",
  your_portfolio: "Suas Artes",
  portfolio_hint: "Arraste para reordenar. A primeira imagem sera sua capa.",
  portfolio_proportion_note:
    "Para melhor exibicao na pagina principal, use uma imagem horizontal (16:9) como capa.",
  portfolio_tags_notice:
    "Clique em qualquer arte para adicionar tags! Tags ajudam clientes a encontrar seu trabalho ao filtrar por especializacao.",
  drag_drop: "Arraste imagens aqui ou",
  or_browse: "",
  browse_files: "clique para escolher",
  max_size: "JPG, PNG, WebP, GIF. Imagens grandes sao comprimidas automaticamente.",
  of: "de",
  upload_complete: "Enviado!",
  no_images: "Nenhuma arte ainda. Envie sua primeira!",
  delete_confirm: "Excluir esta imagem? Essa acao nao pode ser desfeita.",
  image_deleted: "Imagem excluida",
  images: "imagens",

  // Settings
  settings_title: "Configuracoes",
  settings_subtitle: "Gerencie sua conta",
  account: "Conta",
  change_email: "Alterar Email",
  new_email: "Novo Email",
  new_email_placeholder: "Digite o novo email",
  update_email: "Atualizar Email",
  updating: "Atualizando...",
  email_updated: "Email atualizado! Faca login com o novo email.",
  email_update_failed: "Erro ao atualizar email",
  change_password: "Alterar Senha",
  new_password: "Nova Senha",
  confirm_password: "Confirmar Nova Senha",
  password_placeholder: "Digite a senha",
  update_password: "Atualizar Senha",
  password_updated: "Senha atualizada com sucesso!",
  password_update_failed: "Erro ao atualizar senha",
  passwords_dont_match: "As senhas nao coincidem",
  password_too_short: "A senha deve ter pelo menos 6 caracteres",
  danger_zone: "Zona de Perigo",
  danger_hint: "Acoes permanentes e irreversiveis",
  delete_account: "Excluir Conta",

  // Coming soon
  coming_soon: "Em Breve",

  // Portfolio tags
  edit_tags: "Editar Tags",
  select_tags: "Tags da Arte",
  select_tags_hint: "Escolha quais categorias se aplicam a esta arte",
  no_specializations:
    "Primeiro adicione suas especializacoes no Perfil para poder categorizar suas artes.",
  cancel: "Cancelar",
  save: "Salvar",
  tags_saved: "Tags salvas!",
  tags_saved_error: "Erro ao salvar",
  alt_text_label: "Texto Alt (Acessibilidade)",
  alt_text_hint: "Descreva a imagem para leitores de tela e SEO",
  alt_text_placeholder: "Ex.: Retrato de personagem com cabelo azul em armadura fantasia",
  generate_alt: "Gerar",
  generate_alt_tooltip: "Gerar texto alt automaticamente com IA",
  generating_alt: "Gerando...",
  alt_generated: "Texto alt gerado!",
  alt_generate_error: "Falha ao gerar texto alt",

  // Cover
  cover_title: "Imagem de Capa",
  cover_hint: "O banner no topo da sua página de artista. Escolha uma imagem e enquadre-a para cada tamanho de tela.",
  edit_banner: "Editar banner",
  crop_cover: "Recortar Capa",
  apply_crop: "Aplicar Recorte",

  // Content rating
  content_rating: "Classificacao",
  commissioner: "Cliente",
  commissioner_placeholder: "Nome do cliente",
};
